import { useForm, SubmitHandler } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { SignInRequest } from "./api/requestTypes";

export type Inputs = SignInRequest;

const schema = z.object({
  email: z
    .string()
    .min(1, { message: "Enter a valid email address" })
    .email({ message: "Enter a valid email address" }),
  password: z
    .string()
    .regex(
      new RegExp(
        "^(?=.*[a-z])(?=.*[A-Z])(?=.*d)(?=.*[@.#$!%*?&])[A-Za-zd@.#$!%*?&]{8,15}$/"
      ),
      "Enter a valid password with at least one symbol"
    )
});

const defaultValues = {
  email: "",
  password: ""
};

const useSignIn = () => {
  const { handleSubmit, control, errors } = useForm<Inputs>({
    defaultValues,
    resolver: zodResolver(schema)
  });

  const onSubmit: SubmitHandler<Inputs> = data => console.log(data);
  console.log({ errors });
  return {
    handleSubmit: handleSubmit(onSubmit),
    control
  };
};

export default useSignIn;
